import React from "react";
import {
  TextField,
  MenuItem,
  Typography,
  IconButton,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import { ToggleOn, ToggleOff } from "@mui/icons-material";

type WorkOrderSearchBoxProps = {
  selectedOrder: string;
  showOpenOrders: boolean;
  sortWorkOrdersBy: "name" | "date";
  sortedWorkOrders: [string, any][];
  onInputComboChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onToggleShowOpenOrders: () => void;
  onToggleSortWorkOrders: () => void;
  getWorkOrderStatusChip: (status: string | undefined) => JSX.Element;
};

const WorkOrderSearchBox: React.FC<WorkOrderSearchBoxProps> = ({
  selectedOrder,
  showOpenOrders,
  sortWorkOrdersBy,
  sortedWorkOrders,
  onInputComboChange,
  onToggleShowOpenOrders,
  onToggleSortWorkOrders,
  getWorkOrderStatusChip,
}) => {
  return (
    <TextField
      name={"order"}
      id={"order"}
      label={"Work Order"}
      size="small"
      select
      onChange={onInputComboChange}
      value={selectedOrder || "all_orders"}
      margin={"dense"}
      sx={{ width: "500px" }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Tooltip title={showOpenOrders ? "Show all orders" : "Show open orders"}>
              <IconButton onClick={onToggleShowOpenOrders}>
                {showOpenOrders ? <ToggleOn sx={{ color: "green" }} /> : <ToggleOff />}
              </IconButton>
            </Tooltip>
            <Tooltip title={sortWorkOrdersBy === "name" ? "Sort by date" : "Sort by name"}>
              <IconButton onClick={onToggleSortWorkOrders}>
                {sortWorkOrdersBy === "name" ? (
                  <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                    Az
                  </Typography>
                ) : (
                  <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                    🗓️
                  </Typography>
                )}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
    >
      <MenuItem value="all_orders" key="all_orders">
        <Typography fontStyle={"italic"}>Show all applications</Typography>
      </MenuItem>
      <MenuItem value="no_order" key="no_order">
        <Typography fontStyle={"italic"}>Show applications without an order</Typography>
      </MenuItem>
      {Object.values(sortedWorkOrders).map(([orderId, order]) => {
        return (
          <MenuItem
            value={orderId}
            key={orderId}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            {order.name}
            {getWorkOrderStatusChip(order.status)}
          </MenuItem>
        );
      })}
    </TextField>
  );
};

export default WorkOrderSearchBox;
